import React, {FormEvent, useEffect, useState} from "react";
import {dbCall} from "../../helper";
import {api_uris} from "../../app/apiuri";
import {userLoginAction, UserState} from "../../app/user";
import Input from "../Input/Input";
import NcLink from "../NcLink/NcLink";
import ButtonPrimary from "../Button/ButtonPrimary";
import {useAppDispatch} from "../../app/hooks";

export function SignupForm() {
    const [errorMessages, setErrorMessages] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const dispatch = useAppDispatch();

    const refreshCaptcha = (event: React.MouseEvent<HTMLImageElement>) => {
        const img = event.currentTarget as HTMLImageElement;
        if (img) {
            img.src = 'https://dinlebeni.com.tr/api/db-rest/get-db-captcha&rand=' + Math.random();
        }
    }

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        let form = e.currentTarget;
        let data = new FormData(form);

        const username = data.get('username');
        const password = data.get('password');
        const name = data.get('name');
        const captcha = data.get('captcha');

        if (username && password && name) {
            let header = new Headers();
            const response = await dbCall(api_uris.singup_uri, 'post', {
                username: username,
                password: password,
                name: name,
                captcha: captcha
            }, header);

            response.json().then((data) => {
                if (data.success === true) {
                    const payload: UserState = {
                        username: username.toString(),
                        name: data.name,
                        isLogged: true,
                        avatar: data.avatar,
                        isAdmin: data.isAdmin
                    };

                    dispatch(userLoginAction(payload));
                    setIsSubmitted(true);
                    setErrorMessages('');
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 2000);
                } else {
                    setErrorMessages(data.message);
                    setIsSubmitted(false);
                }
            });
        }

        return false;
    }

    return (
        <form className="grid grid-cols-1 gap-6" method="post" onSubmit={handleSubmit}>
            <label className="block">
                <span className="text-neutral-800 dark:text-neutral-200">
                    Adınız Soyadınız:
                </span>
                <Input type="text" className="mt-1" name="name" id={"name"}/>
            </label>

            <label className="block">
                <span className="text-neutral-800 dark:text-neutral-200">
                    Email Adresiniz:
                </span>
                <Input type="email" className="mt-1" name="username" id={"username"}/>
            </label>

            <label className="block">
                    <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                        Parolanız:
                    </span>
                <Input type="password" className="mt-1" name="password" id={"password"}/>
            </label>

            <label className="block">
                    <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                        Doğrulama Kodu(Yenilemek için resme tıklayınız):
                    </span>
                <img src={"https://dinlebeni.com.tr/api/db-rest/get-db-captcha"} id={"imgCaptcha"}
                     alt={"Resim Doğrulama"} onClick={refreshCaptcha} style={{cursor: "pointer"}}/>
                <Input type="text" className="mt-1" name="captcha" id={"captcha"}/>
            </label>


            <ButtonPrimary type="submit">Üye Ol</ButtonPrimary>

            {isSubmitted &&
                <NcLink className="text-green-500" to={"/"}>
                    Üye olduğunuz için teşekkür ederiz.
                    Şimdi anasayfaya yönlendiriliyorsunuz. Yönlendirme çalışmazsa buraya tıklayınız.
                </NcLink>}
            {errorMessages && <div className="text-red-500">{errorMessages}</div>}
        </form>
    );
}